import { useState, useEffect } from "react";
import { FiMoon, FiSun, FiGlobe } from "react-icons/fi";
import { Container, Row, Col } from "reactstrap";
import SocialIcons from "../SocialIcon/SocialIcons";
import { Topbar } from "./Header";
import { useTranslation } from "react-i18next";

const DEFAULT_FONT_SIZE = 16;

const HeaderToolbar = ({ SocialIconsData }) => {
  const { t, i18n } = useTranslation();

  const [lang, setLang] = useState("en");
  // const [lang, setLang] = useState("gu");
  const [fontSize, setFontSize] = useState(DEFAULT_FONT_SIZE);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Load saved language from localStorage and apply to html tag
  useEffect(() => {
    // const savedLang = localStorage.getItem("lang") || "gu";
    const savedLang = localStorage.getItem("lang") || "en";
    setLang(savedLang);
    i18n.changeLanguage(savedLang);
    document.documentElement.lang = savedLang;
  }, [i18n]);

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    setLang(selectedLang);
    i18n.changeLanguage(selectedLang);
    localStorage.setItem("lang", selectedLang);
    document.documentElement.lang = selectedLang;
  };

  // Font size & dark mode
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}px`;

    if (isDarkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }

    const contrastWarningId = "contrast-warning";
    const existing = document.getElementById(contrastWarningId);
    if (existing) existing.remove();

    if (isDarkMode) {
      const color = window.getComputedStyle(document.body).color;
      const rgb = color.match(/\d+/g)?.map(Number);
      const isLowContrast = rgb && rgb.every((v) => v > 150);

      if (isLowContrast) {
        const warning = document.createElement("div");
        warning.id = contrastWarningId;
        warning.textContent =
          "⚠️ Text color is too light for dark background. Adjust for readability.";
        warning.style.color = "#ff0000";
        warning.style.background = "#fff";
        warning.style.padding = "5px 10px";
        warning.style.textAlign = "center";
        document.body.prepend(warning);
      }
    }

    return () => {
      const warn = document.getElementById(contrastWarningId);
      if (warn) warn.remove();
    };
  }, [isDarkMode, fontSize]);

  const toggleDarkMode = () => setIsDarkMode((prev) => !prev);

  return (
    //sm:hidden use for hide in mobile view
    <Topbar
      className={`home-business-topbar border-[#0000001a] header-with-topbar h-15 ${
        isDarkMode ? "bg-[#31572c]" : "bg-[#31572c]"
      }`}
    >
      <Container fluid>
        <Row className="flex flex-nowrap items-center overflow-x-auto whitespace-nowrap">
          {/* Social Icons */}
          <Col className="col-12 text-center md:text-start col-md-auto me-auto ps-lg-0 sm:hidden">
            <SocialIcons
              theme="social-icon-style-01"
              size="sm"
              iconColor={isDarkMode ? "White" : "White"}
              data={SocialIconsData}
            />
          </Col>

          {/* Phone Number */}
          <Col className="col-auto text-end lg:px-0 sm:hidden">
            <span className="top-bar-contact-list py-[9px] px-[18px] text-[13px] inline-block float-left">
              <i className="feather-phone-call text-white mr-[6px] text-md relative top-[1px] text-[17px]" />
              <span className="text-[1.1em] color-white text-white">
                {t("phone")}: +91 97129 24365
              </span>
            </span>
          </Col>

          {/* Font Size Controls */}
          <Col className="col-auto flex items-center">
            <div className="flex items-center gap-2 color-white text-white">
              <button
                onClick={() => setFontSize((s) => Math.max(s - 1, 12))}
                className="px-2 py-1 border hover:bg-[#4c934c] hover:text-warning text-warning rounded-full"
                title="Decrease Font"
              >
                A-
              </button>
              <button
                onClick={() => setFontSize(DEFAULT_FONT_SIZE)}
                className="px-2 py-1 border hover:bg-[#4c934c] hover:text-warning rounded-full"
                title="Reset Font"
              >
                A
              </button>
              <button
                onClick={() => setFontSize((s) => s + 1)}
                className="px-2 py-1 border hover:bg-[#4c934c] hover:text-primary rounded-full"
                title="Increase Font"
              >
                A+
              </button>
            </div>
          </Col>

          {/* Dark Mode Toggle */}
          <Col className="col-auto flex items-center">
            <button
              onClick={toggleDarkMode}
              className="flex items-center text-[13px] text-white"
              aria-label="Toggle Dark Mode"
            >
              {isDarkMode ? (
                <>
                  <FiSun className="mr-1" size={15} />
                </>
              ) : (
                <>
                  <FiMoon className="mr-1" size={15} />
                </>
              )}
            </button>
          </Col>

          {/* Language Switcher */}
          <Col className="col-auto flex items-center">
            <select
              id="lang-switch"
              value={lang}
              onChange={handleLanguageChange}
              className="text-[12px] border rounded px-1 py-[2px] bg-white text-black w-[70px]"
            >
              <option value="en">English</option>
              <option value="hi">हिंदी</option>
              <option value="gu">ગુજરાતી</option>
            </select>
          </Col>
        </Row>
      </Container>
    </Topbar>
  );
};

export default HeaderToolbar;
